import { ChangeDetectionStrategy, Component, input, InputSignal, output,OutputEmitterRef } from '@angular/core';
import { MatAnchor, MatButton } from '@angular/material/button';

@Component({
  selector: 'ui-user-password',
  templateUrl: './user-password.component.html',
  styleUrls: ['./user-password.component.scss'],
  imports: [
    MatAnchor,
    MatButton,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserPasswordComponent {
  public readonly passwordUrl: InputSignal<string | undefined> = input<string | undefined>();
  public readonly linkClicked: OutputEmitterRef<void> = output<void>();
}
